import { DevisClient } from "modules/devis/types/devis.interface";

export enum ReductionType {
  PERCENTAGE = "percentage",
  AMOUNT = "amount",
}

export enum BON_DE_COMMANDE_STATUS {
  DRAFT = "draft",
  VALIDATED = "validated",
  SENT = "sent",
  PAID = "paid",
}

export interface BonDeCommandeLineItem {
  articleId?: string;
  description: string;
  quantity: number;
  unitPriceHT?: number;
  reductionType?: ReductionType;
  reductionAmount?: number;
  vatAmount?: number;
  totalTTC: number;
  totalHT: number;
  priceHT?: number;
}

export interface DocumentSummary {
  totalHT: number;
  totalRemise: number;
  totalHTFinal: number;
  totalVAT: number;
  totalTTC: number;
  vatPercentage: number;
}

export interface BonDeCommande {
  _id: string;
  summary?: DocumentSummary;
  totalTTC: number;
  totalHT: number;
  dueDate: Date;
  createdAt: Date;
  updatedAt: Date;
  status: BON_DE_COMMANDE_STATUS;
  archived: boolean;
  lineItems: BonDeCommandeLineItem[];
  clientId: string;
  client: DevisClient;
  ebpId?: string;
  lastContact?: Date;
  workspaceId: string;
  interveners?: string[];
  devisId?: string;
  documentNumber: {
    number: string;
    prefix: string;
    suffix: string;
  };
  dueAmount?: number;
}

export interface CreateBonDeCommandePayload {
  _id?: string;
  totalTTC: number;
  totalHT: number;
  lineItems: BonDeCommandeLineItem[];
  clientId: string;
  ebpId?: string;
  status?: BON_DE_COMMANDE_STATUS;
  archived?: boolean;
  interveners?: string[];
  dueDate: Date;
  articleId?: string;
  reductionType?: ReductionType;
  reductionAmount?: number;
  devisId?: string;
  documentNumber?: any;
  devisDocumentNumber?: string;
  lastContact?: Date;
}
